var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useMemo } from "react";
import Radio from "./Radio";
import useUniqueId from "../../hooks/useUniqueId";
import { StyledHiddenScreenReaderOnly } from "../../utils/StyleUtils";
import useIdAttrs from "../../hooks/useIdAttrs";
const idPrefix = "radio-group-";
export const RadioGroupContext = createContext(undefined);
const RadioGroup = (_a) => {
    var { children, options, name, value, id: defaultId, "data-insights": insightsAttr, onChange, onFocus, onBlur, disabled, error, autoFocus, display = "block" } = _a, rest = __rest(_a, ["children", "options", "name", "value", "id", "data-insights", "onChange", "onFocus", "onBlur", "disabled", "error", "autoFocus", "display"]);
    const id = useUniqueId(idPrefix, defaultId);
    const idAttrs = useIdAttrs({ id, insightsAttr });
    const groupLabelId = idAttrs("label").id;
    const checkedOption = options === null || options === void 0 ? void 0 : options.find((o) => o.value === value);
    const contextValue = useMemo(() => ({
        name,
        groupDisplay: display,
        selectedOption: value,
        onChangeOption: onChange,
        groupDisabled: disabled,
        groupAutoFocus: autoFocus,
    }), [value, display, onChange, disabled, autoFocus, name]);
    // we only trigger these when the containing div is focused/blurred, which means we
    // have to ignore the bubbling events from the inputs (ie. when there is a relatedTarget)
    const handleOnFocus = (e) => {
        if (onFocus && !e.relatedTarget) {
            onFocus(e);
        }
    };
    const handleOnBlur = (e) => {
        if (onBlur && !e.relatedTarget) {
            onBlur(e);
        }
    };
    return (React.createElement(RadioGroupContext.Provider, { value: contextValue },
        React.createElement("div", Object.assign({}, idAttrs(), { onFocus: handleOnFocus, onBlur: handleOnBlur, role: "radiogroup", "aria-labelledby": groupLabelId }, rest),
            !rest["aria-labelledby"] && (React.createElement(StyledHiddenScreenReaderOnly, { id: groupLabelId }, rest["aria-label"] || name)),
            options
                ? options.map((option, i) => (React.createElement(Radio, Object.assign({ key: i, id: `${id}-${i + 1}`, "data-insights": insightsAttr && `${insightsAttr}-${i + 1}` }, option, { disabled: disabled || option.disabled, error: error, autoFocus: autoFocus && ((checkedOption && checkedOption.value === option.value) || i === 0), display: display }))))
                : children)));
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map